<template>
  <el-carousel :interval="5000" arrow="never" height="520" class="swiper">
    <el-carousel-item v-for="(item, index) in list" class="swiper-item" :key="index">
      <img :src="replace_domain(item.imgUrl)" class="swiper-img" />
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "swiper",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    replace_domain() {
      return (v) => {
        return v.replace(/8.129.187.206/g, "www.hcwisdom888.com");
      };
    },
  },
  data() {
    return {};
  },
  watch: {},
  methods: {},
};
</script>

<style lang="less" scoped>
/deep/.el-carousel__button {
  width: 46px;
  height: 8px;
  background-color: #e3e3e3;
}
/deep/.is-active {
  > button {
    background-color: #444 !important;
  }
}
.swiper {
  min-width: 100%;
  width: 100%;
  height: 520px;
  &-item {
    height: 520px;
  }
  &-img {
    height: 520px;
    width: 100%;
    min-width: 375px;
  }
}
</style>
